const TwitterIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M15.2726 1.58691H18.0838L11.9421 8.60649L19.1673 18.1586H13.51L9.07901 12.3653L4.00894 18.1586H1.19601L7.76518 10.6503L0.833984 1.58691H6.63491L10.6401 6.88219L15.2726 1.58691ZM14.2859 16.4759H15.8436L5.78848 3.18119H4.11687L14.2859 16.4759Z" />
  </svg>
);

export default TwitterIcon;
